@if (block) {
<div class="week-favorites flex flex-col max-w-[90rem] mx-auto w-full px-[1rem] md:px-0 text-left gap-[2rem]">
  @if (title) {
  <div [innerHTML]="title"></div>
  }
  <div class="flex flex-row justify-center">
    <app-first-delivery-recipeweek-selector [canChangeWeek]="canChangeWeek" [flowtype]="flowtype"></app-first-delivery-recipeweek-selector>
  </div>
  @if (loading) {
  <div class="flex justify-center items-center py-10">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-e-orange"></div>
  </div>
  }

  @if (!loading && recipes.length > 0) {
  <div class="mx-[-20px]">
    <div class="auto-slides-per-view auto-slides-per-view-recipes">
      <div class="swiper-button-group hidden lg:flex flex-row justify-between absolute top-[46%] w-full z-10 pointer-events-none">
        <button
          [class]="uniqueId + '-prev swiper-button-prev rounded-full flex flex-row justify-center items-center bg-[#CCE8B5] border-[#CCE8B5] w-10 h-10 pointer-events-auto m-0'"
          aria-label="Previous slide">
          <img class="h-4 w-7 rotate-180" alt="previous slide" src="./assets/images/icons/arrow-right.svg" />
        </button>
        <button
          [class]="uniqueId + '-next swiper-button-next rounded-full flex flex-row justify-center items-center bg-[#CCE8B5] border-[#CCE8B5] w-10 h-10 pointer-events-auto m-0'"
          aria-label="Next slide">
          <img class="h-4 w-7" alt="next slide" src="./assets/images/icons/arrow-right.svg" />
        </button>
      </div>

      <swiper-container #swiperRef init="false" class="w-full">
        @for (recipe of recipes; track recipe.id; let i = $index) {
        <swiper-slide class="flex flex-col h-auto">
          <div class="flex items-stretch w-full flex-grow">
            <app-featured-card class="flex items-stretch w-full" [recipe]="recipe" [persons]="selectedPersons[recipe.id] || 2" [selected]="false"
              [selectedlifestyles]="lifestyleid ? [lifestyleid] : []" [status]="'PERSONEDITABLE'" (selectedChange)="onRecipeSelected($event, recipe)"
              (personsChange)="onPersonsChange($event, recipe.id)">
            </app-featured-card>
          </div>
        </swiper-slide>
        }
      </swiper-container>
    </div>
  </div>
  }

  @if (!hasRecipes) {
  <div id="busychef" class="flex flex-row mt-5 mb-5 justify-center">
    <img alt="Onze Chef" class="h-[150px]" src="assets/images/chef-menu.svg" />
  </div>
  <div class="mb-5 w-full mt-3 text-center block">{{'subscription.still_creating_menu' | translate}}</div>
  }

  @if (description) {
  <div class="text-[1rem] text-e-dark-green text-center mx-auto max-w-[28rem] font-nib-pro" [innerHTML]="description"></div>
  }

  @if (button) {
  <div class="flex justify-center">
    <app-cms-button [button]="button"></app-cms-button>
  </div>
  }

  @if (link && linkName) {
  <div class="flex justify-center">
    @if (isExternalLink(link)) {
    <a [href]="link" target="_blank" rel="noopener noreferrer"
      class="button-base bg-e-reg-green text-e-dark-green rounded-full h-[2rem] flex flex-col justify-center font-[600] text-[0.875rem] hover:bg-e-dark-green hover:text-e-reg-green font-nib-pro min-w-[9rem]">{{
      linkName }}</a>
    } @else {
    <a [routerLink]="link"
      class="button-base bg-e-reg-green text-e-dark-green rounded-full h-[2rem] flex flex-col justify-center font-[600] text-[0.875rem] hover:bg-e-dark-green hover:text-e-reg-green font-nib-pro min-w-[9rem]">{{
      linkName }}</a>
    }
  </div>
  }

</div>
}